function NumberField({

    value,

    onChange,

    suffix

}){

    return(

        <div
            style={{
                display:"flex",
                alignItems:"center",
                gap:"10px"
            }}
        >

            <input

                type="number"

                value={value}

                onChange={(e)=>onChange(e.target.value)}

                style={{

                    flex:1,

                    height:"42px",

                    borderRadius:"10px",

                    border:"1px solid #ddd",

                    paddingLeft:"12px",

                    textAlign: "right"

                }}

            />

            <b>{suffix}</b>

        </div>

    );

}

export default NumberField;